import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import View from '../view.js';
/**
 * A view displaying an information text related to different states of {@link module:ui/search/text/searchtextview~SearchTextView}.
 *
 * @internal
 */
var SearchInfoView = /*#__PURE__*/function (_View) {
  _inherits(SearchInfoView, _View);
  var _super = _createSuper(SearchInfoView);
  /**
   * @inheritDoc
   */
  function SearchInfoView() {
    var _this;
    _classCallCheck(this, SearchInfoView);
    _this = _super.call(this);
    var bind = _this.bindTemplate;
    _this.set({
      isVisible: false,
      primaryText: '',
      secondaryText: ''
    });
    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-search__info', bind.if('isVisible', 'ck-hidden', function (value) {
          return !value;
        })],
        tabindex: -1
      },
      children: [{
        tag: 'span',
        children: [{
          text: [bind.to('primaryText')]
        }]
      }, {
        tag: 'span',
        children: [{
          text: [bind.to('secondaryText')]
        }]
      }]
    });
    return _this;
  }
  /**
   * Focuses the view
   */
  _createClass(SearchInfoView, [{
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }]);
  return SearchInfoView;
}(View);
export { SearchInfoView as default };